import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

interface TVariables {
  confirmEvent: { id: number; user: number; confirmation: string };
}

interface TData {
  confirmToOperateEvent: {
    id: string;
    confirmation?: string | null;
  };
}

interface Args {
  operatorId: string;
  userId: string;
  confirmation: string;
}

/*
 * Sets the assigned operator's confirmation for an event
 * ("accepted" | "pending" | "rejected"). The returned EventOperator is
 * normalized by id, so Apollo updates the cached confirmation automatically.
 */
const MUTATION = gql`
  mutation ConfirmToOperateEvent($confirmEvent: ConfirmEventInput!) {
    confirmToOperateEvent(confirmEvent: $confirmEvent) {
      id
      confirmation
    }
  }
`;

export const useConfirmOperator = (): [(args: Args) => Promise<void>] => {
  const [mutation] = useMutation<TData, TVariables>(MUTATION);

  return [
    useCallback(
      async (args: Args): Promise<void> => {
        await mutation({
          variables: {
            confirmEvent: {
              id: Number(args.operatorId),
              user: Number(args.userId),
              confirmation: args.confirmation
            }
          }
        });
      },
      [mutation]
    )
  ];
};

export type UseConfirmOperatorHook = typeof useConfirmOperator;
